/**
 * O canal da tarifa como o viajante lê (#6895): o hotels-api devolve em
 * `supplier.name` também consolidadores e bedbanks ("Iterpec", "EZ Link
 * Hotel"), nomes que não dizem nada a quem compra. Só as marcas de consumidor
 * desta lista aparecem; o resto é tarifa VOLL. A lista é do time de hotel.
 *
 * Casa pela PRIMEIRA palavra, sem acento e sem caixa (`titleTokens`): pega
 * "Expedia Internacional" e "Decolar.com" sem casar "Bookingpro".
 */
import { titleTokens } from '@voll-intelligence/genui-contract';

const BRAND_BY_FIRST_TOKEN: ReadonlyMap<string, string> = new Map([
  ['decolar', 'Decolar'],
  ['expedia', 'Expedia'],
  ['booking', 'Booking.com'],
]);

/** O nome que entra numa frase quando o canal não é marca de consumidor. */
const VOLL_CHANNEL = 'VOLL';

export function hotelChannelBrand(supplierName: string | undefined): string | undefined {
  const [first] = supplierName ? titleTokens(supplierName) : [];
  return first ? BRAND_BY_FIRST_TOKEN.get(first) : undefined;
}

export function hotelChannelName(supplierName: string): string {
  return hotelChannelBrand(supplierName) ?? VOLL_CHANNEL;
}
